import { useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Autocomplete from "components/DesignComponents/Autocomplete";
import AutocompleteListBox from "components/Filters/components/AutocompleteListBox";
import TableContext from "context/table/tableContext";
import {
    DROPDOWN_SIZES,
    Filter,
    FILTER_NAMES,
    filterDropdownCustomWidth,
    handleAutocompleteInputValueChange
} from "shared";

const AllPermissions = () => {
    const {
        innerTableInitialRows,
        innerTableFilteredValues,
        setInnerTableParams
    } = useContext(TableContext);

    const { t } = useTranslation();

    const [inputValue, setInputValue] = useState("");
    const [value, setValue] = useState<Filter[]>([]);

    // Set value
    useEffect(() => {
        const actualFilter = innerTableFilteredValues.find(
            filteredValue =>
                filteredValue.filterName === FILTER_NAMES.AllPermissions
        );

        const newValue = actualFilter ? actualFilter.value : [];

        setValue(prevValue => {
            const isEqual =
                JSON.stringify(prevValue) === JSON.stringify(newValue);

            return isEqual ? prevValue : newValue;
        });
    }, [innerTableFilteredValues]);

    const handleChange = (newValue: Filter[]) => {
        const paramsPayload = {
            [FILTER_NAMES.AllPermissions]: newValue.map(item => String(item.id))
        };

        const filteredValuesPayload = {
            filterName: FILTER_NAMES.AllPermissions,
            value: newValue
        };

        setInnerTableParams({
            params: paramsPayload,
            filteredValues: filteredValuesPayload
        });
    };

    return (
        <Autocomplete
            fullWidth
            multiple
            size={DROPDOWN_SIZES.Small}
            disableClearable
            disableCloseOnSelect
            inputValue={inputValue}
            value={value}
            options={innerTableInitialRows}
            onInputChange={(_, newInputValue, reason) =>
                handleAutocompleteInputValueChange(reason, () =>
                    setInputValue(newInputValue)
                )
            }
            onChange={(_, newFilterValue) => handleChange(newFilterValue)}
            slots={{
                listbox: AutocompleteListBox
            }}
            renderValue={() => null}
            textFieldParams={{
                placeholder: t("Filter##all permissions")
            }}
            getOptionLabel={(option: Filter) => t(`General##${option.name}`)}
            css={css(filterDropdownCustomWidth)}
        />
    );
};

export default AllPermissions;
